import { getAxiosInstance } from '../api.client';
import {
    type Preliminary,
    type PreliminaryDetail,
    type PreliminaryFormModel,
} from './preliminaries.models';

export async function getPreliminaries(
    projectId: string,
): Promise<Preliminary[]> {
    const response = await getAxiosInstance().get<Preliminary[]>(
        `/project/${projectId}/preliminary`,
    );
    return response.data;
}

export async function getPreliminaryById(
    projectId: string,
    id: string,
): Promise<PreliminaryDetail> {
    const response = await getAxiosInstance().get<PreliminaryDetail>(
        `/project/${projectId}/preliminary/${id}`,
    );
    return response.data;
}

export async function createPreliminary(
    projectId: string,
    data: PreliminaryFormModel,
): Promise<Preliminary> {
    const response = await getAxiosInstance().post<Preliminary>(
        `/project/${projectId}/preliminary`,
        data,
    );
    return response.data;
}

export async function updatePreliminary(
    projectId: string,
    id: string,
    data: PreliminaryFormModel,
): Promise<Preliminary> {
    const response = await getAxiosInstance().put<Preliminary>(
        `/project/${projectId}/preliminary/${id}`,
        data,
    );
    return response.data;
}

export async function deletePreliminary(
    projectId: string,
    id: string,
): Promise<void> {
    await getAxiosInstance().delete(`/project/${projectId}/preliminary/${id}`);
}

export interface CompletePreliminaryRequest {
    completionDate?: string | null;
}

export async function completePreliminary(
    projectId: string,
    id: string,
    data?: CompletePreliminaryRequest,
): Promise<Preliminary> {
    const response = await getAxiosInstance().post<Preliminary>(
        `/project/${projectId}/preliminary/${id}/complete`,
        data ?? {},
    );
    return response.data;
}

export async function reactivatePreliminary(
    projectId: string,
    id: string,
): Promise<Preliminary> {
    const response = await getAxiosInstance().post<Preliminary>(
        `/project/${projectId}/preliminary/${id}/reactivate`,
    );
    return response.data;
}
